import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SeasonalIdea, SeasonalIdeasResponse } from '../../components/campaigns/types';

interface SeasonalIdeasState {
  data: SeasonalIdea[];
  loading: boolean;
  error: string | null;
  count: number;
}

const initialState: SeasonalIdeasState = {
  data: [],
  loading: false,
  error: null,
  count: 0,
};

const seasonalIdeasSlice = createSlice({
  name: 'seasonalIdeas',
  initialState,
  reducers: {
    fetchSeasonalIdeasRequest: (state, _action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchSeasonalIdeasSuccess: (state, action: PayloadAction<SeasonalIdeasResponse>) => {
      state.loading = false;
      state.data = action.payload.data;
      state.count = action.payload.count;
      state.error = null;
    },
    fetchSeasonalIdeasFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSeasonalIdeasRequest,
  fetchSeasonalIdeasSuccess,
  fetchSeasonalIdeasFailure,
} = seasonalIdeasSlice.actions;

export default seasonalIdeasSlice.reducer;
